import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueRouter from 'vue-router'
import router from './router'
import Vuex from 'vuex'
import store from './store'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import config from './aws-exports'

import OneSignalVue from "onesignal-vue";
import VuetifyTimeSelect from 'vuetify-time-select'
import PubNubVue from 'pubnub-vue';
import Toasted from 'vue-toasted';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueTour from 'vue-tour'
import VueCompositionAPI from '@vue/composition-api';

Vue.use(VueCompositionAPI);

require('vue-tour/dist/vue-tour.css')

Vue.use(VueTour)
 



Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 5,
  newestOnTop: true,
  position: "top-center",
  timeout: 0,
  closeOnClick: true,
  pauseOnFocusLoss: false,
  pauseOnHover: false,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  bodyClassName: ["text-style"],
  closeButton: "button",
  icon: {
    iconClass: "material-icons",
    iconChildren: "check_circle",
    iconTag: "span"
  },
  rtl: false,
   toastClassName: "toast-style",
});


//https://github.com/shakee93/vue-toasted/blob/master/examples/using-icons.js
Vue.use(Toasted, {
    theme: "outline", //['toasted-primary', 'outline', 'bubble']
    //type: 'success',
    //icon : 'accessibility',
    class: "",
    width: 400,
    position: 'top-center',
    showCloseButton: true,
    //fitToScreen: true,
    //fullWidth: true,
    dismissible: true , 
    iconPack : 'material' // set your iconPack, defaults to material. material|fontawesome|custom-class

});

// https://github.com/fontzter/vuetify-time-select
Vue.component('vuetify-time-select', VuetifyTimeSelect)

Amplify.configure(config)

Vue.use(AmplifyPlugin, AmplifyModules)
Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(OneSignalVue);


// how do you add the user ID here?
Vue.use(PubNubVue, {
    subscribeKey: 'sub-c-498e325f-4ce9-4bd6-b632-4aa77b2399e4',
    publishKey: 'pub-c-622931ce-7ab1-4c1c-962a-df2939574f51'
});


Vue.config.productionTip = false

new Vue({
  vuetify,
  router,   
  store,
  render: h => h(App),

  beforeMount() {
    
  },


}).$mount('#app')
